import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';

import { FileMultiUploaderEntity, FileUploaderEntity, ToFormControls } from '@rp/shared/models';

export const addFile = (
  value: FileUploaderEntity = null,
  validators: ValidatorFn | ValidatorFn[] | null = null,
): FormGroup<ToFormControls<FileMultiUploaderEntity>> => {
  return new FormGroup({
    file: new FormControl(value, {
      validators,
    }),
  });
};
